export default __webpack_public_path__ + "a1529936ee2258f6729557f01906cc3d.png";